import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuildiumLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_45316_112635)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M40 8C40 3.58172 36.4183 0 32 0H8C3.58172 0 0 3.58172 0 8V32C0 36.4183 3.58172 40 8 40H32C36.4183 40 40 36.4183 40 32V8Z",
			fill: "#70B37F"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M28.4865 6.55469L21.2065 8.29469C20.7552 8.40802 20.1385 8.78269 19.8478 9.13335L11.5132 19.6107H14.3172V30.1007C14.3172 30.5634 14.6679 31.0534 15.1225 31.1894L21.7612 33.2054V19.6107H18.1665L28.4865 6.55469Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_45316_112635",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgBuildiumLogo;
